import Player from '@vimeo/player';

export const hero = () => {
    const heroVideoElement = document.querySelector('.hero--video');

    if (!heroVideoElement) {
        return;
    }

    // Get video ID from data attribute
    const videoId = heroVideoElement.getAttribute('data-video-id');

    if (!videoId) {
        return;
    }

    const markIframe = (frame) => {
        frame.setAttribute('title', 'Background video');
        frame.setAttribute('role', 'presentation');
    };

    // Prefer the iframe rendered in the block HTML so the accessible name
    // is in the response the scanner captures.
    let iframe = heroVideoElement.querySelector('iframe');

    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.src = `https://player.vimeo.com/video/${encodeURIComponent(videoId)}?autoplay=1&muted=1&background=1&loop=1&controls=0&badge=0`;
        iframe.allow = 'autoplay; fullscreen; picture-in-picture';
        iframe.style.width = '100%';
        iframe.style.height = '100%';
        iframe.frameBorder = '0';
        heroVideoElement.appendChild(iframe);
    }

    markIframe(iframe);

    // Initialize Vimeo player
    const player = new Player(iframe);

    // Add is-loaded class when video is ready
    player.ready().then(() => {
        markIframe(iframe);
        heroVideoElement.classList.add('is-loaded');
    });

    // Add is-playing class when playing
    player.on('play', function () {
        heroVideoElement.classList.add('is-playing');
    });

    // Remove is-playing class when paused
    player.on('pause', function () {
        heroVideoElement.classList.remove('is-playing');
    });

    // Remove is-playing class when ended
    player.on('ended', function () {
        heroVideoElement.classList.remove('is-playing');
    });
}